import React, {useEffect, useState} from "react";
import {Button, FormControl, Grid, Paper, TextField, Tooltip} from "@material-ui/core";
import {DatePicker, KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import _ from "lodash";
import InputComboBox from "../sharedFormComponents/InputComboBox";
import DeleteIcon from "@material-ui/icons/Delete";

import AddIcon from "@material-ui/icons/Add";
import FundedPropertyForm from "../fundedProperties/FundedPropertyForm";
import {Autocomplete} from "@material-ui/lab";
import axios from "axios";
import {CurrencyFormatter} from "./Formatters";

const PastRealEstateInvestment = (
    {
        session, pastRealEstateInvestmentData, index,
        realEstateInvestmentHistory, setRealEstateInvestmentHistory, investmentStyles,
        handleOnChangeInField, handleOnError, removeRealEstateInvestmentError,
        isEditing, isNew, deleter, ...props
    }
) => {
    const [trackedRealEstateInvestment, setTrackedRealEstateInvestment] = useState({ ...pastRealEstateInvestmentData })
    const [fundedPropertyError, setFundedPropertyError] = useState(!isEditing);
    const [openFundedPropertyForm, setOpenFundedPropertyForm] = useState(false);
    const [investmentDate, setInvestmentDate] = useState(trackedRealEstateInvestment.investment_date ? new Date(trackedRealEstateInvestment.investment_date) : null);
    const [fundedProperties, setFundedProperties] = useState({ open: false, data: [] })
    const [selectedFundedProperty, setSelectedFundedProperty] = useState({});

    useEffect(() => {
        if (isEditing) handleFetchFundedProperties(false, {filter: trackedRealEstateInvestment.funded_property_name})
    }, [])

    const requiredErrors = () => {
        return fundedPropertyError || !_.isNumber(trackedRealEstateInvestment.investment_style_id) || !_.isDate(investmentDate)
    }

    useEffect(() => {
        handleOnError(requiredErrors());
    }, [
        fundedPropertyError, trackedRealEstateInvestment.investment_style_id, investmentDate
    ]);

    useEffect(() => {
        setInvestmentDate(trackedRealEstateInvestment.investment_date ? new Date(trackedRealEstateInvestment.investment_date) : null)
    }, [
        trackedRealEstateInvestment.investment_date
    ]);

    const handleFundedPropertyChange = (funded_property) => {
        setTrackedRealEstateInvestment(prevState => ({
            ...prevState,
            funded_property: funded_property || {},
            funded_property_id: funded_property?.id || '',
            funded_property_name: funded_property?.name || ''
        }));

        setSelectedFundedProperty(funded_property);
        setFundedPropertyError(_.isEmpty(funded_property))
    }

    useEffect(() => {
        if (trackedRealEstateInvestment._destroy) {
            const newRealEstateInvestmentHistory = realEstateInvestmentHistory.filter((trackedRealEstateInvestment, i) => index !== i);
            setRealEstateInvestmentHistory(newRealEstateInvestmentHistory)
            removeRealEstateInvestmentError(index)
        } else {
            let newRealEstateInvestmentHistory = [...realEstateInvestmentHistory];
            newRealEstateInvestmentHistory[index] = trackedRealEstateInvestment;
            setRealEstateInvestmentHistory(newRealEstateInvestmentHistory);
        }
    }, [trackedRealEstateInvestment])

    const handleDateChange = (date) => {
        setTrackedRealEstateInvestment(prevState => ({
            ...prevState,
            investment_date: date,
        }));
    }

    const handleOnChange = (event) => {
        event.persist();

        if (['amount_invested', 'total_raised'].includes(event.target.name) && event.target.value) {
            event.target.value = event.target.value.replace(/[^0-9.-]+/g,"");
        }

        setTrackedRealEstateInvestment(prevState => ({
            ...prevState,
            [event.target.name]: event.target.value,
        }));
    }

    const handleRemoveTrackedRealEstateInvestment = async () => {
        if (window.confirm('Are you sure you want to delete this investment?')) {
            if (trackedRealEstateInvestment.id) {
                await deleter.realEstateInvestments(trackedRealEstateInvestment);
            }

            setTrackedRealEstateInvestment(prevState => ({
                ...prevState,
                _destroy: true,
            }));
            if (props.setSelectedRealEstateInvestmentHistory) {
                props.setSelectedRealEstateInvestmentHistory(null)
            }
        }
    }

    const errorMessage = {};

    const handleCloseForm = () => {
        setOpenFundedPropertyForm(false);
    }

    const handleFetchFundedProperties = (open, params = {}) => {
        const newParams = {
            page: 1,
            per_page: 50,
            ...params
        };

        axios.get(
          '/v1/admin/funded_properties/fintrx_data',
          {
              params: newParams,
              headers: {
                  'Content-Type': 'multipart/form-data',
                  'X-Admin-User-Email': session.email,
                  'X-Admin-User-Token': session.token
              }
          }
        ).then((response) => {
            const { funded_properties, status: responseStatus } = response.data;
            setFundedProperties({ open: open, data: funded_properties })

            if (trackedRealEstateInvestment.funded_property_id) {
                const selected = _.find(funded_properties, (option) => (option.id === trackedRealEstateInvestment.funded_property_id))
                if (selected) setSelectedFundedProperty(selected)
            } else
                setFundedPropertyError(true)
        });
    }

    const handleOpenFundedProperties = (open) => {
        if (open === true) {
            handleFetchFundedProperties(true, { funded_property_id: trackedRealEstateInvestment.funded_property_id })
        } else {
            setFundedProperties({ open: false, data: [],})
        }
    }
    const handleInputChangeAutocomplete = (event, field) => {
        event.persist();
        debounceFilterInput(event, field);
    }

    const debounceFilterInput = _.debounce((event) => {
        handleFetchFundedProperties(true, { filter: event.target.value })
    }, 500)


    const RenderPastRealEstateInvestmentContainer = () => {
        return <Grid container spacing={3} className='admin-investment-history-fields'>
            <Grid item xs={11}>
                <h4>{ isNew && "Real Estate Investment Form"}</h4>
            </Grid>
            <Grid item xs={1}>
                <Button onClick={handleRemoveTrackedRealEstateInvestment} className="error">
                    <DeleteIcon />
                </Button>
            </Grid>
            <Grid item xs={4}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                        disableFuture
                        inputVariant="outlined"
                        label="Investment Date"
                        format="MM/dd/yyyy"
                        value={investmentDate}
                        onChange={handleDateChange}
                        error={!_.isDate(investmentDate)}
                        fullWidth
                        required
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                    />
                </MuiPickersUtilsProvider>
                <span>{errorMessage['investment_date']}</span>
            </Grid>

            <Grid item xs={4}>
                <FormControl fullWidth>
                    <TextField
                      label="Amount Invested"
                      variant="outlined"
                      name='amount_invested'
                      value={trackedRealEstateInvestment.amount_invested || ''}
                      onBlur={handleOnChange}
                      InputLabelProps={{ shrink: trackedRealEstateInvestment.amount_invested !== ''}}
                      InputProps={{
                          inputComponent: CurrencyFormatter
                      }}
                    />
                    <span>{errorMessage['amount_invested']}</span>
                </FormControl>
            </Grid>

            <Grid item xs={4}>
                <FormControl fullWidth>
                    <TextField
                        label="Transaction Value"
                        variant="outlined"
                        name='total_raised'
                        value={trackedRealEstateInvestment.total_raised || ''}
                        onBlur={handleOnChange}
                        InputLabelProps={{ shrink: trackedRealEstateInvestment.total_raised !== ''}}
                        InputProps={{
                            inputComponent: CurrencyFormatter
                        }}
                    />
                    <span>{errorMessage['total_raised']}</span>
                </FormControl>
            </Grid>

            <Grid item container xs={8} style={{alignItems: "center"}}>
                <Grid xs={10}>
                    <Autocomplete
                      // filterSelectedOptions={true}
                      name="Funded Property"
                      open={fundedProperties.open}
                      onOpen={(event) => handleOpenFundedProperties(true)}
                      onClose={(event) => handleOpenFundedProperties(false)}
                      onChange={(event, value) => handleFundedPropertyChange(value)}
                      getOptionSelected={(option, value) => option.id === value.id}
                      getOptionLabel={(option) => option.name ? `${option.name}, ${option.address || ''} ${option.city || ''} ${option.state || ''}` : ''}
                      value={selectedFundedProperty}
                      options={fundedProperties.data}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Funded Property"
                          variant="outlined"
                          onChange={(event) => handleInputChangeAutocomplete(event, 'funded_property_id')}
                          required
                          error={fundedPropertyError}
                        />
                      )}
                    />
                </Grid>

                <Grid xs={2}>
                    <Tooltip title="New Funded Property">
                        <Button onClick={() => setOpenFundedPropertyForm(true)} className="create" style={{minWidth: "unset", marginLeft: "8px"}}>
                            <AddIcon />
                        </Button>
                    </Tooltip>
                </Grid>
                <span>{errorMessage['funded_property_id']}</span>
            </Grid>

            <Grid item xs={4}>
                <InputComboBox
                    value={trackedRealEstateInvestment.investment_style_id || ''}
                    label={'Investment Style'}
                    field={'investment_style_id'}
                    name={'investment_style_id'}
                    handleOnChange={handleOnChange}
                    options={investmentStyles}
                    menuClass={'input-combo-menu'}
                    error={!_.isNumber(trackedRealEstateInvestment.investment_style_id)}
                    required
                />
            </Grid>
            {
                openFundedPropertyForm && <FundedPropertyForm
                        adminUserSession={session}
                        onClose={handleCloseForm}
                        open={openFundedPropertyForm}
                        afterCreateFundedProperty={handleFundedPropertyChange}
                        onDataUpdate={() => {}}
                        itemIndex={0}
                    />
            }
        </Grid>
    }

    return (
        trackedRealEstateInvestment._destroy === true ? null :
            <>
                {
                    isNew ? <Paper elevation={3} className={"paper-sub-form"}>
                        {RenderPastRealEstateInvestmentContainer()}
                    </Paper> : RenderPastRealEstateInvestmentContainer()
                }
            </>
    )
}

export default PastRealEstateInvestment